import {Component, input, InputSignal, OnInit} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-status-label',
  imports: [
    NgClass
  ],
  templateUrl: './status-label.html',
  styleUrl: './status-label.css'
})
export class StatusLabel implements OnInit {
  status: InputSignal<string | boolean | undefined> = input<string | boolean | undefined>();
  width: InputSignal<number | string | undefined> = input<number | string | undefined>();

  styleClass: string = '';
  label: string = '';

  ngOnInit(): void {
    this._setStatusStyles();
  }

  setLabel(label?: string): void {
    if (label) {
      this.label = label;
      return;
    }
    this.label = this.status() as string;
  }

  private _setStatusStyles(): void {
    switch (this.status()) {
      case 'ACOLHIDA':
        this.styleClass = 'bg-[#E1FCEF] text-[#14804A]'; // Verde
        this.setLabel('Acolhida');
        break;
      case 'CANCELADA':
        this.styleClass = 'bg-[#FAF0F3] text-[#D12953]'; // Vermelho
        this.setLabel('Cancelada');
        break;
      case 'ARBITRAL':
        this.styleClass = 'bg-[#F0F1FA] text-[#4F5AED]'; // Azul
        this.setLabel('Arbitral');
        break;
      case 'EM ANÁLISE':
        this.styleClass = 'bg-[#F0F1FA] text-[#4F5AED]'; // Azul
        this.setLabel('Em análise');
        break;
      case 'TAP':
        this.styleClass = 'bg-[#FCF2E6] text-[#AA5B00]'; // Laranja
        this.setLabel();
        break;
      case 'ANULADA':
        this.styleClass = 'bg-[#E9EDF5] text-[#5A6376]'; // Cinza
        this.setLabel('Anulada');
        break;
      case undefined:
      case false:
        this.styleClass = 'bg-[#E9EDF5] text-[#5A6376]'; // Cinza
        this.setLabel('Desconhecido');
        break;
    }
    this.styleClass += ` ${this.width() ? `w-[${this.width()}]` : ''}`;
  }
}
